import Keycloak from 'keycloak-js'

/**
 * Shared mutable reference to the Keycloak instance.
 *
 * KeycloakProvider sets this after fetching runtime config and
 * creating the instance. apiClient reads it for token management.
 *
 * This avoids creating Keycloak at module-load time (which would
 * bake in build-time defaults), while still allowing non-React code
 * like apiClient to access the instance.
 */
let instance: Keycloak | null = null

export function setKeycloakInstance(kc: Keycloak): void {
    instance = kc
}

export function getKeycloakInstance(): Keycloak | null {
    return instance
}
